<template>
	<div class="w-100 p-3" v-if="flds.ok">
		<div class="w-100 pb-3 pl-3 pr-3 border-15 border overflow-auto shadow">
			<div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 float-right">
				<selectInput
					label="گروه آموزشی"
					:value="val.d"
					:flds="flds.data"
					@inputTxtFunc = "(e)=>{val.d = e; val.c = ''}"
				/>
			</div>
			<div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 float-right">
				<selectInput
					:value="val.c"
					:flds="flds.data[indexFinder(flds.data, val.d)].category"
					@inputTxtFunc = "(e)=>{val.c = e}"
					label="انتخاب موضوع درس"
				/>
			</div>
			<div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 float-right">
				<selectInput
					:value="val.l"
					:flds="location"
					@inputTxtFunc = "(e)=>{val.l = e}"
					label="انتخاب شهر"
				/>
				<span class="d-none">
				2	{{ location }}
				</span>
			</div>
			<div class="col-lg-3 col-md-12 col-sm-12 col-xs-12 pt-3 float-right h-center">
				<btn
					class="w-100"
					style="margin-top: 15px;"
					textClass="w-100"
					type="success"
					text="جستجو"
					@clickMe="srch()"
				/>
			</div>
		</div>
	</div>
</template>

	<script>
		import btn from  "../../../UI/button/btn.vue";
		import selectInput from  "../../../UI/input/selectInput.vue";
		import { indexFinder } from  "../../../assets/library/filter.js";
		export default {
			name: 'p_home',
			data(){
				return {
					val:{
						d: 1,
						c: "",
						l: "",
					},
					indexFinder: indexFinder,
					location: [],
				}
			},
			components: {
				btn,
				selectInput,
			},
			props: {
				flds: {
					default: {"ok": false,},
				},
			},
			mounted( THIS = this){
				
				this.loader();
			},
			methods:{
				loader(THIS= this){
				
					window.$.get(window.baseurl+'/location/highlights', { }, function(D_location){
						document.body.scrollTop = 0;
						THIS.location = D_location.data;
					}, "json");
				},
				srch(){
					let c = (this.val.c != '') ? "category=" + this.val.c : 'category=0';
					let d = (this.val.d != '') ? "degrees=" + this.val.d : 'degrees=0';
					let l = (this.val.l != '') ? "location=" + this.val.l : 'location=0';
					// this.$router.push('/teachers?'+d+'&'+c+'&'+l)
					location.replace('/teachers?'+d+'&'+c+'&'+l);
				},
			}
		}
	</script>
<style>

</style>
